import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

/**
 * Renders an authenticated image fetched via /api/files/{storage_path}.
 * Falls back to base64 `data` field for legacy reports.
 */
export default function ReportImage({ image, className = "", alt = "" }) {
    const [src, setSrc] = useState("");

    useEffect(() => {
        let revoke;
        let cancelled = false;
        async function load() {
            if (!image) return;
            if (image.data && image.mime) {
                setSrc(`data:${image.mime};base64,${image.data}`);
                return;
            }
            if (image.storage_path) {
                try {
                    const { data: t } = await api.get("/auth/file-token");
                    if (cancelled) return;
                    const url = `${API}/files/${image.storage_path}?auth=${encodeURIComponent(t.token)}`;
                    setSrc(url);
                } catch {
                    setSrc("");
                }
            }
        }
        load();
        return () => { cancelled = true; if (revoke) URL.revokeObjectURL(revoke); };
    }, [image]);

    if (!src) {
        return <div className={`bg-paper border border-rule rounded-sm ${className}`} />;
    }
    return <img src={src} alt={alt || image?.filename || "image"} className={className} />;
}
